import { DataTable } from '../../components/admin/data-table';
import { DateField } from '../../components/admin/date-field';
import { MoonstarList } from '../Moonstar/MoonstarList';
import { SmsMessageFilters } from './SmsMessageFilters';
import { SmsMessageResendAction } from './SmsMessageResendAction';
import { SmsMessageToolbarActions } from './SmsMessageToolbarActions';
import { type SmsMessage } from './types';

export const SmsMessageList = () => (
  <MoonstarList<SmsMessage>
    actions={<SmsMessageToolbarActions />}
    filters={SmsMessageFilters}
    sort={{ field: 'timestamp', order: 'DESC' }}
  >
    <DataTable<SmsMessage>
      bulkActionButtons={<SmsMessageResendAction />}
      isRowSelectable={(record) => record.resendAllowed}
    >
      <DataTable.Col source="internalId" label="Internal ID" />
      <DataTable.Col source="firstName" />
      <DataTable.Col source="lastName" />
      <DataTable.Col source="phoneNumber" />
      <DataTable.Col source="status" />
      <DataTable.Col source="details" disableSort />
      <DataTable.Col source="timestamp">
        <DateField
          source="timestamp"
          showTime
          options={{
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          }}
        />
      </DataTable.Col>
    </DataTable>
  </MoonstarList>
);
